import { Link as GatsbyLink } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

const BadgeLink = ({ children, to, small, ...other }) => {
  return (
    <GatsbyLink
      to={to}
      css={{
        ...theme[small ? 'smallcaps' : 'lead'],
        color: theme.colors.spinachDark,
        backgroundColor: 'rgba(19, 79, 70, 0.09)',
        borderRadius: '4px',
        padding: '4px 12px',
        marginBottom: '8px',
        marginRight: '8px',
        display: 'inline-block',
        width: 'fit-content',
        '&:hover': {
          textDecoration: to ? 'underline' : 'none',
        },
      }}
      {...other}
    >
      {children}
    </GatsbyLink>
  )
}

export default BadgeLink

BadgeLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  small: PropTypes.bool,
}
